import React, { useEffect } from 'react'
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import Datepicker from '../../../../common/datePicker'
import { SplitButton } from '../../../../common/SplitButton'
import { RefreshSvg } from '../../../../common/svg/refresh'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { useState } from 'react'
import FranchiseeBookingSummary from './FranchiseeBookingSummary'
import FranchiseeBookingDetailed from './FranchiseeBookingDetailed'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { getOwnBookingFilterData, getBookingFranchiseeTableData } from '../../../../../store/reports/reports_action'
import { connect } from 'react-redux'
import { lrStatusView, reportView, transType, urls } from '../../../../common/constants'
import moment from 'moment/moment'
import { appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { bookingSummaryColumn, franchiseeBookingDetailedColumnsForPortraite, franchiseeBookingDetailedColumnsWithFormattedLRNO, franchiseeBookingDetailedExcelHeader, franchiseeDetailedHeader } from '../BookingConstants'
import { updateAlert, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import * as URL from '../../oldReportsUrls'
import ManageColumns from '../../../../common/ManageColumnsUI'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { useAtom, useSetAtom } from 'jotai'
import { companySettingsAtom } from '../../../../common/jotaiState/commonStateAtoms'
import { GT_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { GetRequest } from '../../../../common/api'
import { alertAtom, globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
export const PAYTYPE_RULES = {
    2: "COD",
    7: "COD(MANUAL)",
};
const FranchiseeBookingsNew = (props) => {
    const {
        data: { common, reports },
        getOwnBookingFilterData,
        updateAlert, updateAlertError, updateModal
    } = props
    const { loginData, roleRights, showModal, modalType } = common
    const [companySettings] = useAtom(companySettingsAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)
    const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
    const BookingReportPortrait = companySettings?.BookingReportPortrait
    const loginCountryId = companySettings?.DefaultCurrencyID || 0
    const { DefaultCurrencyID, IsHamaliInBookingReport, UseToPayAsCOD } = companySettings || {}
    const { ownBookingDropData, BookingFranchiseeTableData } = reports
    const [showReport, setShowReport] = useState(false)
    const [tableData, setTableData] = useState([])
    const [sourceBranchOpt, setSourceBranchOpt] = useState([])
    const [sourceBranchUserOpt, setSourceBranchUserOpt] = useState([])
    const [selCompany, setSelCompany] = useState('')
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [sourceCity, setSourceCity] = useState('')
    const [sourceCityData, setSourceCityData] = useState([])
    const [sourceBranch, setSourceBranch] = useState('')
    const [sourceBranchUser, setSourceBranchUser] = useState('')
    const [franchiseeCompany, setFranchiseeCompany] = useState('')
    const [destinationBranch, setDestinationBranch] = useState('')
    const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [transactionType, setTransactionType] = useState(transType?.[0])
    const [selReportView, setSelReportView] = useState(reportView?.[1])
    const [status, setStatus] = useState(lrStatusView?.[0])
    const [checkCrossinglr, setCheckCrossinglr] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [manageColumn, setManageColumn] = useState([])
    const { intCompanyID, intUserID } = loginData
    const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
    const [ChildCompanyList] = useAtom(ChildCompanyListData)
    const reportName = 'Franchisee Booking Report'
    const summaryheaders = bookingSummaryColumn.filter(col => {
        if (DefaultCurrencyID === 2 && col.field === 'BookingGST') return false;
        if (!IsHamaliInBookingReport && col.field === 'HamaliCharges') return false;
        return true;
    }).map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                headerName: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
                exportHead: DefaultCurrencyID === 2 ? 'Insurance\nCharge' : 'Valuation\nCharge',
            };
        }
        return col;
    });
    const criteriaHeaders = [
        { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
        { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
        { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
        { field: 'sourceBranchUser', header: 'Source Branch User', textAlign: 'left' },
        { field: 'franchiseeCompany', header: 'Franchisee Company', textAlign: 'left' },
        { field: 'destinationBranch', header: 'Franchisee Branch', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'transactionType', header: 'TransactionType', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
        { field: 'status', header: 'LR Status', textAlign: 'left' },
    ]
    const criteriaData = {
        selCompany: selCompany?.CompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        sourceCity: sourceCity?.SourceCityName || '',
        sourceBranch: sourceBranch?.SourceBranchName || '',
        sourceBranchUser: sourceBranchUser?.UserBooked || '',
        franchiseeCompany: franchiseeCompany?.DeliveryCompany || '',
        destinationBranch: destinationBranch?.DestBranchName || '',
        paymentType: paymentType?.name || '',
        transactionType: transactionType?.TransType || '',
        selReportView: selReportView?.ReportView || '',
        status: status?.LrStatus || '',
        dataType: 'entry',
    }
    const handleClick1 = () => {
        if (sourceCity == '' || sourceCity == ' ') {
            updateAlertError({ show: true, msg: 'Select Source City', nextId: '' })
        } else if (sourceBranch == '' || sourceBranch == ' ') {
            updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' })
        } else if (sourceBranchUser == '' || sourceBranchUser == ' ') {
            updateAlertError({ show: true, msg: 'Select Branch User', nextId: '' })
        } else {
            const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
            const isAllSelected = sourceCity?.SourceCityID === 0 || sourceBranch?.SourceBranchID === 0 || sourceBranchUser?.UserID === 0
            if (isAllSelected && diffDays > 15) {
                updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
            } else if (!isAllSelected && diffDays > 31) {
                updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
            } else {
                setShowReport(true)
                const object = {
                    CompanyID: selCompany?.CompanyID,
                    SourceCityID: sourceCity?.SourceCityID || 0,
                    SourceBranchID: sourceBranch?.SourceBranchID || 0,
                    DateFrom: moment(fromDate).format('YYYY-MM-DD'),
                    DateTo: moment(toDate).format('YYYY-MM-DD'),
                    UserID: sourceBranchUser?.UserID || 0,
                    FranchCompanyID: franchiseeCompany?.DeliveryCompanyID || 0,
                    DestCityID: 0,
                    DestBranchID: destinationBranch?.DestBranchID || 0,
                    PaymentTypeIDs: paymentType.typeId || 0,
                    Mode: transactionType?.TransId || 0,
                    StatusCode: status?.LrId || 0,
                    IsCrossingCity: checkCrossinglr ? 1 : 0,
                    LoggedInUser: loginData?.intUserID,
                    AllowViewAllReport: 1,
                }
                setLoader(true)
                GetRequest(urls.getBookingFranchiseeData, object)
                    .then((res) => {
                        if (res.status !== 'Success') {
                            throw new Error(res?.ErrMessage || 'Request Failed')
                        }
                        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
                            throw new Error('No Data Found')
                        }
                        let data = res?.Data?.Table
                        const updatedData =
                            UseToPayAsCOD === 1
                                ? data.map((item) => ({
                                    ...item,
                                    PayType: PAYTYPE_RULES[item.PaymentTypeID] || item.PayType,
                                }))
                                : data

                        let mainHeader = []
                        let manageColIdValue = ''
                        if (BookingReportPortrait === 1) {
                            manageColIdValue = 'franchiseeBookingDetailedColumnsForPortraite'
                        } else {
                            manageColIdValue = 'franchiseeBookingDetailedColumns22'
                        }
                        let reportPayload = {}
                        if (selReportView?.ReportId === '1') {
                            const headers = manageColumn.filter((col) => col.isSelected)
                            const reportData = groupingData(updatedData, headers)
                            mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
                                ...val,
                                align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                                export: val.exportHead,
                                weight: 80
                            }))
                            reportPayload = {
                                reportName,
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                isShowManageColumn: true,
                                manageColumnID: manageColIdValue,
                                colSpanMarker: "STATUS",
                                hideHeader: true
                            }
                        } else if (selReportView?.ReportId === '0') {
                            const reportData = summaryData(updatedData)
                            mainHeader = summaryheaders.map((val) => ({
                                ...val,
                                header: val.headerName,
                                align: val.xlCol.dataType === 'string' ? 'left' : 'right',
                                export: val.exportHead,
                                weight: 80
                            }))
                            reportPayload = {
                                reportName,
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                hideHeader: true
                            }
                        }

                        const rid = Date.now().toString()

                        if (!window.generatedReports) {
                            window.generatedReports = {}
                        }

                        window.generatedReports[rid] = reportPayload

                        window.open(`/view-report?rid=${rid}`, "_blank")
                    })
                    .catch((err) => {
                        setTableData([])
                        setAlert({ show: true, msg: err.message, nextId: '' })
                    })
                    .finally(() => {
                        setLoader(false)
                    })
            }
        }
    }

    const handleClick2 = () => {
        if (transactionType?.TransId === 1) {
            updateAlert({ show: true, msg: 'Booked Trans. Not Allowed' })
        } else {
            let url = URL.BookingFranchiseeReport
            let urlData = URL.BookingFranchiseeReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.dtFromDate = moment(fromDate).format('DD-MMM-YYYY')
            urlData.dtToDate = moment(toDate).format('DD-MMM-YYYY')
            urlData.intCompanyID = loginData?.intCompanyID
            urlData.intBranchID = sourceBranch.SourceBranchID
            urlData.intpaymentType = paymentType.typeId
            urlData.intUserID = sourceBranchUser?.UserID
            urlData.intLoggedInUser = loginData?.intUserID
            urlData.Isrefund = transactionType?.TransId ? 2 : 0 //based on AllTransiction Dropdown
            urlData.AllowViewAllReport = 1
            urlData.companyname = loginData.strCompanyName
            urlData.FranchCompID = franchiseeCompany.DeliveryCompanyID
            urlData.FranchBranchID = destinationBranch.DestBranchID //here franchBranchId
            urlData.isSummaryOnly = selReportView?.[1] ? 1 : 0
            urlData.intAllowExportExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }
    const handleGoClick = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            const obj = {
                CompanyID: selCompany?.CompanyID,
                FromDate: moment(fromDate).format('YYYY-MM-DD'),
                ToDate: moment(toDate).format('YYYY-MM-DD'),
                FranchCompID: -1,
            }
            getOwnBookingFilterData(obj)
        }
    }
    const groupingData = (array, headers) => {
        const lengths = divideInNIntegers(headers.length, 3)
        let index = 0
        const pickedHeaders = []
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index]?.field)
            index += span
        })
        const createEmptyTotals = () => ({
            Quantity: 0,
            Freight: 0,
            CartageAmount: 0,
            HamaliCharges: 0,
            DocumentCharges: 0,
            Valuation: 0,
            OtherCharges: 0,
            BookingGST: 0,
            NetAmount: 0,
        });

        const numericFields = Object.keys(createEmptyTotals());

        const BookedData = [];
        const RefundData = [];
        let BookedTotal = createEmptyTotals();
        let RefundTotal = createEmptyTotals();
        let BookingSN = 0;
        let RefundSN = 0;

        const pushFormattedRow = (val, index) => ({
            ...val,
            dataType: "entry",
            srNo: index + 1,
            itemDesc: val.ItemDetails,
            DstCityBranch: `${val.DestCityName}\n${val.DestBranchName}`,
            BkgDtTimeBy: `${moment(val.BkgDtTime).format("DD-MMM-YY HH:mm")}\n${val.UserBooked}`,
            SenderNameGSTN: `${val.Sender}\n${val.SenderGSTN}`,
            recNameGstin: `${val.RecName}\n${val.RecGSTN}`,
            Status: val.STATUS,
            SenderContEmail: `${val.SenderMobileNo}\n${val.SenderEmailID}`,
            RecContEmail: `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
            "LRNO^^ManualLRNo": `${val.LRNO}\n${val.ManualLRNo}`,
            "Sender^^SenderGSTN": `${val.Sender}\n${val.SenderGSTN}`,
            "SenderMobileNo^^SenderEmailID": `${val.SenderMobileNo}\n${val.SenderEmailID}`,
            "RecMobileNo^^ReceiverEmailID": `${val.RecMobileNo}\n${val.ReceiverEmailID}`,
            "RecName^^RecGSTN": `${val.RecName}\n${val.RecGSTN}`,
            "BkgDtTime^^UserBooked": `${moment(val.BkgDtTime).format("DD-MMM-YY HH:mm")}\n${val.UserBooked}`,
            "DestCityName^^DestBranchName": `${val.DestCityName}\n${val.DestBranchName}`,
        });

        const addToTotal = (totalObj, val) => {
            numericFields.forEach((f) => (totalObj[f] += Number(val[f])));
        };

        array?.forEach((val) => {
            if (val.IsRefund === 0) {
                BookedData.push(pushFormattedRow(val, BookingSN++));
                addToTotal(BookedTotal, val);
            } else {
                RefundData.push(pushFormattedRow(val, RefundSN++));
                addToTotal(RefundTotal, val);
            }
        });

        const makeSubHeading = (type) => ({
            dataType: 'subHeader',
            colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
            align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
            [pickedHeaders[0]]: `Transactions: ${type}`,
            [pickedHeaders[1]]: `Source City: ${sourceCity?.SourceCityName}`,
            [pickedHeaders[2]]: `Destination Company: ${franchiseeCompany?.DeliveryCompany}`,
        })

        const headerCol = headers.reduce((a, c) => ((a[c.field] = c.header), a), {})

        let DetailedData = [];

        const pushSection = (heading, rows, totals, transLabel) => {
            DetailedData.push(
                heading,
                { dataType: 'header', ...headerCol },
                ...rows,
                {
                    dataType: 'total',
                    align: { [pickedHeaders[0]]: 'right' },
                    colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'Quantity') },
                    [pickedHeaders[0]]: `Total: Src. City: ${sourceCity?.SourceCityName},Src. Branch: ${sourceBranch?.SourceBranchName},Trans: ${transLabel}`,
                    ...totals,
                }
            );
        };

        if (transactionType?.TransId === 0 || transactionType?.TransId === 1)
            pushSection(makeSubHeading("Booked"), BookedData, BookedTotal, "Booked");

        if (transactionType?.TransId === 0 || transactionType?.TransId === 2)
            pushSection(makeSubHeading("Refund"), RefundData, RefundTotal, "Refund");

        if (transactionType?.TransId === 0) {
            const GrandTotal = numericFields.reduce((a, f) => ((a[f] = BookedTotal[f] - RefundTotal[f]), a), {})
            DetailedData.push({
                dataType: 'total',
                align: { [pickedHeaders[0]]: 'right' },
                colSpan: { [pickedHeaders[0]]: headers.findIndex((header) => header.field === 'Quantity') },
                [pickedHeaders[0]]: `Total: Src. City: ${sourceCity?.SourceCityName},Src. Branch: ${sourceBranch?.SourceBranchName},Trans:(Booked-Refund)`,
                ...GrandTotal,
            });
        }
        return DetailedData;
    };
    const summaryData = (array) => {
            if (array.length === 0) {
                return []
            }
        const colspans = divideInNIntegers(summaryheaders.length, 3)
        const newArray = array.map((val, index) => ({
            ...val,
            SN: index + 1,
            DocumentCharges: val.DocumentCharges || 0,
            dataType: "entry"
        }));
        const numericFields = [
            "LRCount",
            "ItemUnits",
            "Freight",
            "CartageAmount",
            "HamaliCharges",
            "Valuation",
            "OtherCharges",
            "BookingGST",
            "Amount",
            "RefundAmt",
            "NetAmount",
            "DocumentCharges"
        ];

        const totals = newArray.reduce(
            (acc, val) => {
                numericFields.forEach((field) => {
                    acc[field] += Number(val[field] || 0);
                });
                return acc;
            },
            Object.fromEntries(numericFields.map((f) => [f, 0]))
        );

        newArray.push({
            SN: "Total",
            colSpan: { SN: 2 },
            ...totals,
            dataType: "total"
        });
        const headerObject = summaryheaders.reduce((acc, v) => {
            acc[v.field] = v.headerName;
            return acc;
        }, { dataType: 'header' });
        newArray.unshift(headerObject)
        newArray.unshift({
            [summaryheaders[0].field]: `Source City: ${sourceCity?.SourceCityName}`,
            [summaryheaders[colspans[0]].field]: `Destination Company: ${franchiseeCompany?.DeliveryCompany}`,
            [summaryheaders[colspans[0] + colspans[1]].field]: `Transaction: ${transactionType?.TransType}`,
            dataType: 'subHeader',
            colSpan: { SN: colspans[0], [summaryheaders[colspans[0]].field]: colspans[1], [summaryheaders[colspans[0] + colspans[1]].field]: colspans[2] }
        });
         newArray.unshift({
                SN: `Booking Report`,
                dataType: 'header',
                colSpan: { SN: summaryheaders.length },
            })
        return newArray;
    };
   
    useEffect(() => {
        const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) || ChildCompanyList[0]
        setSelCompany(defaultCompany)
    }, [ChildCompanyList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intCompanyID: intCompanyID,
                UserID: intUserID,
            }
            fetchChildCompanyList(body)
        }
    }, [loginData])
    useEffect(() => {
        if (!isEmpty(roleRights)) {
            setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
            setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
        }
    }, [roleRights])
    const [franchiseeCompanyListOpt, setFranchiseeCompanyListOpt] = useState([])
    const [franchiseeBranchListOpt, setFranchiseeBranchListOpt] = useState([])

    useEffect(() => {
        if (ownBookingDropData?.Data?.Table) {
            let sourceCityList = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'SourceCityID')
            setSourceCityData([{ SourceCityName: "All Cities", SourceCityID: 0 }, ...sourceCityList])
            const selectedCity = sourceCityList?.filter((val) => val.SourceCityID === loginData?.intBranchCityID)
            if (disableBtn) {
                setSourceCity({ SourceCityName: loginData.strCityName, SourceCityID: loginData.intBranchCityID })
            } else {
                if (selectedCity?.length > 0) {
                    setSourceCity(selectedCity?.[0])
                } else {
                    setSourceCity({ SourceCityName: "All Cities", SourceCityID: 0 })
                }
            }
            let sourceBranchList = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'SourceBranchID')
            setSourceBranchOpt([{ SourceBranchName: "All Branch", SourceBranchID: 0 }, ...sourceBranchList])
            const selectedBranch = sourceBranchList?.filter((val) => val.SourceBranchID === loginData?.intBranchID)
            if (selectedBranch?.length > 0) {
                setSourceBranch(selectedBranch?.[0])
            } else {
                setSourceBranch({ SourceBranchName: "All Branch", SourceBranchID: 0 })
            }
            let sourceBranchUserList = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'UserID')
            setSourceBranchUserOpt([{ UserBooked: "All Branch User", UserID: 0 }, ...sourceBranchUserList])
            const selectedUser = sourceBranchUserList?.filter((val) => val.UserID === loginData?.intUserID)
            if (selectedUser?.length > 0) {
                setSourceBranchUser(selectedUser?.[0])
            } else {
                setSourceBranchUser({ UserBooked: "All Branch User", UserID: 0 })
            }
            let franchiseeCompanyList = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'DeliveryCompanyID')
            setFranchiseeCompanyListOpt(franchiseeCompanyList)
            setFranchiseeCompany(franchiseeCompanyList[0])
            let franchiseeBranchList = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'DestBranchID')
            setFranchiseeBranchListOpt([{ DestBranchName: "All", DestBranchID: 0 }, ...franchiseeBranchList])
            setDestinationBranch({ DestBranchName: "All", DestBranchID: 0 })
        }
    }, [ownBookingDropData])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    const updatedColumns = franchiseeBookingDetailedColumnsWithFormattedLRNO(UseFormattedLRinReports, loginCountryId)
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }
        const updateColumnDetails = async () => {
            try {
                if (BookingReportPortrait === 1) {
                    let usedCols = []
                    const franchiseeBookingDetailedColumnsForPortraiteCol = await getLocalData('franchiseeBookingDetailedColumnsForPortraite')
                    usedCols = franchiseeBookingDetailedColumnsForPortraiteCol || franchiseeBookingDetailedColumnsForPortraite
                    if (UseFormattedLRinReports !== 3) {
                        usedCols = usedCols.filter((item) => item.field !== 'FormattedLRNO')
                    }
                    if (intCompanyID === GT_COMPANY_ID) {
                        usedCols = usedCols.map((item) => {
                            if (item.field === 'CartageAmount') {
                                return { ...item, header: 'Addl. \nCartage', exportHead: 'Addl. \nCartage' }
                            }
                            return item
                        })
                    }
                    setManageColumn(usedCols)
                } else {
                    const updatedColumnsCol = await getLocalData('franchiseeBookingDetailedColumns22')
                    let usedCols = updatedColumnsCol || updatedColumns
                    usedCols = usedCols
                        .map((col) => {
                            if (DefaultCurrencyID === 2) {
                                if (col.field === 'Valuation') {
                                    return {
                                        ...col,
                                        header: 'Insu.\nChrg.',
                                        exportHead: 'Insurance Charge',
                                    }
                                }
                                if (col.field === 'Sender^^SenderGSTN') {
                                    return {
                                        ...col,
                                        header: 'Sndr. Name',
                                        exportHead: 'Sender Name',
                                    }
                                }
                                if (col.field === 'RecName^^RecGSTN') {
                                    return {
                                        ...col,
                                        header: 'Rcvr. Name',
                                        exportHead: 'receiver Name',
                                    }
                                }
                                if (col.field === 'BookingGST') {
                                    return false
                                }
                            }
                            if (col.field === 'CartageAmount' && intCompanyID === GT_COMPANY_ID) {
                                return {
                                    ...col,
                                    header: 'Addl. \nCartage',
                                    exportHead: 'Additional Cartage',
                                }
                            }
                            return col
                        })
                        .filter(Boolean)

                    setManageColumn(usedCols)
                }

            } catch (error) {
                console.error(error)
            }
        }
        updateColumnDetails()
    }, [UseFormattedLRinReports, BookingReportPortrait, loginCountryId, intCompanyID])
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    const onSaveColumns = (items) => {
        setManageColumn(items)
        if (BookingReportPortrait === 1) {
            localStorage.setItem('franchiseeBookingDetailedColumnsForPortraite', JSON.stringify(items))
        } else {
            localStorage.setItem('franchiseeBookingDetailedColumns22', JSON.stringify(items))
        }
    }
    const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})

    return (
        <>
            <Box sx={sx.reportFlex}>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id="selectCompnay"
                        label="Selected Company"
                        data={ChildCompanyList}
                        defaultvalue={selCompany?.CompanyName}
                        disabled={false}
                        onSelect={(val) => setSelCompany(val)}
                        dataKey={`CompanyName`}
                        idKey={`CompanyID`}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        value={fromDate}
                        dateDiff={365}
                        name={'from_booking_date'}
                        label={lb.fromBookingDate}
                        id={'fromDate'}
                        nextId={'toDate'}
                        prevId={'fromDate'}
                        dateChange={(date) => { setFromDate(date); focusElemnt('toDate') }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                    <Datepicker
                        value={toDate}
                        name={'to_booking_date'}
                        label={lb.toBookingDate}
                        id={'toDate'}
                        nextId={'franchiseeBookingGoBtn'}
                        prevId={'fromDate'}
                        dateChange={(date) => { setToDate(date); focusElemnt('franchiseeBookingGoBtn') }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <Button id='franchiseeBookingGoBtn' variant="contained" className="go click-button" onClick={handleGoClick} onKeyDown={(e) => navigation3(e, 'sourceCity', 'fromDate', handleGoClick)}>
                        GO
                    </Button>
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Source City"
                        id="sourceCity"
                        nextId={'sourceBranch'}
                        prevId={'franchiseeBookingGoBtn'}
                        data={sourceCityData || []}
                        defaultvalue={sourceCity?.SourceCityName || sourceCity}
                        dataKey={`SourceCityName`}
                        idKey={`SourceCityID`}
                        disabled={disableBtn}
                        onSelect={(val) => {
                            setShowReport(false)
                            setSourceCity(val)
                            setSourceBranch(' ')
                            let result = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'SourceBranchID')?.filter(
                                (obj) => obj.SourceCityID === val.SourceCityID || val?.SourceCityID === 0 || obj.SourceBranchID === 0
                            )
                            setSourceBranchOpt([{ SourceBranchName: 'All Branch', SourceBranchID: 0 }, ...result])
                            setSourceBranch({ SourceBranchName: "All Branch", SourceBranchID: 0 })
                        }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Source Branch"
                        id="sourceBranch"
                        nextId={'sourceBranchUser'}
                        prevId={'sourceCity'}
                        // data={removeDuplicatesFromArray(sourceBranchData, 'SourceBranchID') || []}
                        data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? [{ SourceBranchName: "All Branch", SourceBranchID: 0 }, ...sourceBranchOpt?.filter((val) => val.SourceBranchID == loginData?.intBranchCityID)] : sourceBranchOpt}
                        defaultvalue={sourceBranch?.SourceBranchName || sourceBranch}
                        disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        dataKey={`SourceBranchName`}
                        idKey={`SourceBranchID`}
                        onSelect={(branch) => {
                            setShowReport(false)
                            setSourceBranch(branch)
                            setSourceBranchUser(' ')
                            let resultUser = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'UserID')?.filter(
                                (obj) => obj.SourceBranchID === branch.SourceBranchID
                            )
                            // setSourceBranchUserOpt(resultUser)
                            setSourceBranchUserOpt([{ UserBooked: "All User", UserID: 0 }, ...resultUser])
                            setSourceBranchUser({ UserBooked: "All User", UserID: 0 })
                        }}
                        width="170px"
                        listWidth={'250px'}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Source Branch User"
                        id="sourceBranchUser"
                        nextId={'franchisee'}
                        prevId={'sourceBranch'}
                        defaultvalue={sourceBranchUserOpt?.length > 0 && sourceBranchUser?.UserBooked || sourceBranchUser}
                        data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? [{ UserBooked: "All Branch", UserID: 0 }, ...sourceBranchUserOpt?.filter((val) => val.UserID == loginData?.intUserID)] : sourceBranchUserOpt || []}
                        dataKey={`UserBooked`}
                        disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        idKey={`UserID`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setFranchiseeCompany(' ')
                            setSourceBranchUser(val)
                            let result = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'UserID')?.filter(
                                (obj) => obj.UserID === val.UserID
                            )
                            setFranchiseeCompanyListOpt(result)
                            // setFranchiseeCompanyListOpt([{ DeliveryCompany: "All", DeliveryCompanyID: 0 },...result])
                            // setFranchiseeCompany(franchiseeCompany?.DeliveryCompany)
                        }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label=" Franchisee Company"
                        id="franchisee"
                        nextId={'franchiseeBranch'}
                        prevId={'sourceBranchUser'}
                        defaultvalue={franchiseeCompany?.DeliveryCompany || franchiseeCompany}
                        data={franchiseeCompanyListOpt}
                        dataKey={`DeliveryCompany`}
                        idKey={`DeliveryCompanyID`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setFranchiseeCompany(val)
                            setDestinationBranch(' ')
                            let result = removeDuplicatesFromArray(ownBookingDropData?.Data?.Table, 'DestBranchID')?.filter(
                                (obj) => obj.DeliveryCompanyID === val.DeliveryCompanyID || val?.DeliveryCompanyID === 0 || obj.DestBranchID === 0
                            )
                            // setFranchiseeBranchListOpt(result)
                            setFranchiseeBranchListOpt([{ DestBranchName: "All", DestBranchID: 0 }, ...result])
                            setDestinationBranch({ DestBranchName: "All", DestBranchID: 0 })
                        }}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Franchisee Branch"
                        id="franchiseeBranch"
                        nextId={'paymentType'}
                        prevId={'franchisee'}
                        defaultvalue={destinationBranch?.DestBranchName || destinationBranch}
                        data={franchiseeBranchListOpt}
                        dataKey={`DestBranchName`}
                        idKey={`DestBranchID`}
                        onSelect={(obj) => {
                            setShowReport(false)
                            setDestinationBranch(obj)
                        }}
                        width="170px"
                        listWidth={'250px'}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label={'Payment Type'}
                        // data={paymentModesWithAll || []}
                        data={(paymentModesWithAll || []).map((item) => {
                            if (UseToPayAsCOD === 1) {
                                if (item.typeId === 2) {
                                    return { ...item, name: 'COD' };
                                }
                                if (item.typeId === 7) {
                                    return { ...item, name: 'COD Manual' };
                                }
                                if (item.typeId === 9) {
                                    return { ...item, name: 'COD DDDV' };
                                }
                                if (item.typeId === 4) {
                                    return null;
                                }
                            }
                            return item;
                        }).filter(Boolean)
                        }
                        id="paymentType"
                        nextId={'TransactionType'}
                        prevId={'franchiseeBranch'}
                        defaultvalue={paymentType?.name || ''}
                        width="100%"
                        searchPlaceholder={`Search By Payment Type`}
                        tabIndex="2"
                        dataKey={`name`}
                        idKey={`typeId`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setPaymentType(val)
                        }}
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        label="Txn.Type"
                        id="TransactionType"
                        nextId={'ReportView'}
                        prevId={'paymentType'}
                        defaultvalue={transactionType?.TransType || ''}
                        data={transType}
                        onSelect={(val) => {
                            setShowReport(false)
                            setTransactionType(val)
                        }}
                        dataKey={`TransType`}
                        idKey={`TransId`}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id="ReportView"
                        nextId={'LrStatus'}
                        prevId={'TransactionType'}
                        label="Report View"
                        data={reportView}
                        defaultvalue={selReportView?.ReportView || ''}
                        dataKey={`ReportView`}
                        onSelect={(val) => {
                            setShowReport(false)
                            setSelReportView(val)
                        }}
                        idKey={`ReportId`}
                        width="170px"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id="LrStatus"
                        nextId={'FranchiseeChechBox'}
                        prevId={'ReportView'}
                        label="LR Status"
                        data={lrStatusView}
                        defaultvalue={status?.LrStatus || ''}
                        dataKey={`LrStatus`}
                        idKey={`LrId`}
                        width="170px"
                        listWidth={'250px'}
                        onSelect={(val) => {
                            setShowReport(false)
                            setStatus(val)
                        }}
                    />
                </Item>
                <FormControlLabel
                    id="FranchiseeChechBox"
                    value="end"
                    control={<Checkbox id={id.onlyRefund} />}
                    className={`${checkCrossinglr ? 'selcheck' : 'unselcheck'}`}
                    label="Include Crossing LRs?"
                    labelPlacement="end"
                    checked={checkCrossinglr}
                    onChange={() => {
                        setCheckCrossinglr(!checkCrossinglr)
                    }}
                    onKeyDown={(e) => { navigation3(e, 'franchiseeSplitBtn', 'LrStatus') }}
                />
                <Item
                    sx={sx.itemsx}
                    style={{ cursor: 'pointer' }}
                    onKeyDown={(e) => navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'OwnChechBox', () => handleClick1())}
                >
                    <SplitButton
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        // hideToggle={true}
                        id1={'franchiseeSplitBtn'}
                        prevID={'FranchiseeChechBox'}
                        onClick1={handleClick1}
                        onClick2={handleClick2}
                    />
                </Item>
                <Item sx={sx.itemsx} className="flex-center-all">
                    <RefreshSvg />
                </Item>
            </Box>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnBookingFilterData, getBookingFranchiseeTableData, updateAlert, updateAlertError, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseeBookingsNew)
